import { useSelector } from 'react-redux';
// redux
import { selectLocationsList } from 'redux/locations/locationsSelectors';

const useCities = () => {
  const cities = useSelector(selectLocationsList);

  return {
    cities,
  };
};

export default useCities;
